import React from 'react'
// import '../../../components/journey-builder/style/delay-editor.scss'
import { DayPartSelect, IDayPartValue } from '@pushly/aqe/lib/components'
import clone from 'clone-deep'
import {
    calculateDelayQualifiedValue,
    calculateDelaySecondsValue,
    DEFAULT_DELAY_QUALIFIER,
    DEFAULT_DELAY_SECONDS,
    DEFAULT_EXCLUDED_DAYS,
    DelayQualifier,
} from './helpers'
import { tryParseFloat } from '../../../_utils/try-parse'
import { Form, Input, Select } from 'antd'

export const RelativeDelayPicker = ({ value, showExclusions, onChange, disabled }: any) => {
    const delaySeconds = value.delay_seconds ?? DEFAULT_DELAY_SECONDS
    const delayQualifier = value.qualifier ?? DEFAULT_DELAY_QUALIFIER

    const excludedDays: any = showExclusions ? clone(DEFAULT_EXCLUDED_DAYS) : []
    if (showExclusions && value.excluded_days) {
        value.excluded_days.forEach((day: string) => {
            excludedDays[day] = false
        })
    }

    let qualifiedValue: any = calculateDelayQualifiedValue(delaySeconds, delayQualifier)
    if (/^0./.test(qualifiedValue.toString())) {
        qualifiedValue = qualifiedValue.toString().replace(/^0/gi, '')
    }

    return (
        <>
            <Input
                className="relative-delay-picker"
                size="small"
                type="number"
                min={1}
                max={60}
                autoComplete="off"
                defaultValue={calculateDelayQualifiedValue(DEFAULT_DELAY_SECONDS, DEFAULT_DELAY_QUALIFIER)}
                value={qualifiedValue}
                disabled={disabled}
                addonAfter={
                    <Select
                        className="journey-delay-editor-qualifier-selection"
                        dropdownClassName="journey-delay-editor-qualifier-dropdown"
                        value={delayQualifier}
                        disabled={disabled}
                        onChange={(qualifier: DelayQualifier) => {
                            onChange({
                                qualifier,
                                delay_seconds: calculateDelaySecondsValue(qualifiedValue, qualifier),
                            })
                        }}
                    >
                        <Select.Option value="minutes">minute(s)</Select.Option>
                        <Select.Option value="hours">hour(s)</Select.Option>
                        <Select.Option value="days">day(s)</Select.Option>
                    </Select>
                }
                onChange={(ev: React.ChangeEvent<HTMLInputElement>) => {
                    let qv: string | number = ev.target.value
                    if (qv === '') {
                        qv = 0
                    }

                    const parsed: number = tryParseFloat(qv.toString())
                    qv = parsed < 0 ? 1 : parsed

                    onChange({
                        qualifier: delayQualifier,
                        delay_seconds: calculateDelaySecondsValue(qv, delayQualifier),
                    })
                }}
            />

            {showExclusions && (
                <Form.Item label="Execute next step on the following days">
                    <DayPartSelect
                        daysOnly={true}
                        dayFormat={'ddd'}
                        weekBeginsOnSunday={true}
                        defaultValue={DEFAULT_EXCLUDED_DAYS}
                        value={excludedDays}
                        onChange={(days) => {
                            const dayKeys = Object.keys(days)
                            const skipDays = dayKeys.filter((key: keyof IDayPartValue) => !days[key])

                            onChange({
                                qualifier: delayQualifier,
                                delay_seconds: delaySeconds,
                                excluded_days: skipDays.length > 0 ? skipDays : undefined,
                            })
                        }}
                    />
                </Form.Item>
            )}
        </>
    )
}
